var _path, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZoomIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 1.07373C4.69365 1.07373 1 5.03926 1 9.931C1 14.8227 4.69365 18.7883 9.25 18.7883C11.2581 18.7883 13.0987 18.018 14.5293 16.7376L20.2197 22.8469C20.5126 23.1613 20.9874 23.1613 21.2803 22.8469C21.5732 22.5324 21.5732 22.0226 21.2803 21.7081L15.59 15.5989C16.7825 14.063 17.5 12.0869 17.5 9.931C17.5 5.03926 13.8063 1.07373 9.25 1.07373ZM2.5 9.931C2.5 5.92867 5.52208 2.68414 9.25 2.68414C12.9779 2.68414 16 5.92867 16 9.931C16 13.9333 12.9779 17.1779 9.25 17.1779C5.52208 17.1779 2.5 13.9333 2.5 9.931Z",
    fill: "#111111"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_416_6770)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3 5.36816C9.52853 5.36816 9.71379 5.56706 9.71379 5.81242V9.21835H12.8863C13.1148 9.21835 13.3 9.41724 13.3 9.6626C13.3 9.90795 13.1148 10.1069 12.8863 10.1069H9.71379V13.5128C9.71379 13.7581 9.52853 13.957 9.3 13.957C9.07147 13.957 8.88621 13.7581 8.88621 13.5128V10.1069H5.71384C5.48531 10.1069 5.30005 9.90795 5.30005 9.6626C5.30005 9.41724 5.48531 9.21835 5.71384 9.21835H8.88621V5.81242C8.88621 5.56706 9.07147 5.36816 9.3 5.36816Z",
    fill: "#111111"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_416_6770"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8.58887,
    fill: "white",
    transform: "translate(5.30005 5.36816)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoom-in.dffa0504.svg";
export { ForwardRef as ReactComponent };